import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {EntityStateAdapter} from '@/store/base.store';
import {GalleryModel} from '@/models/gallery.model';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';
import {PaginatedParams} from '@/api/base.api';

export const featureKey = 'gallery';

// @ts-ignore
if (store.state.galley) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class GalleryStoreModule extends EntityStateAdapter<GalleryModel> {

  get gallery(): GalleryModel[] {
    return this._entities;
  }

  get currentPage(): number {
    return this._currentPage;
  }

  get loading(): boolean {
    return this._loading;
  }

  get lastPage(): number {
    return this._lastPage;
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchGallery(data: { challengeId: number, params: PaginatedParams }): Promise<GalleryModel[]> {
    this.updateLoading(true);
    const response = await (new ChallengesApi())
      .getGallery(data.challengeId, data.params)
      .pipe(take(1))
      .toPromise();
    this.context.commit('updateAllPageParams', response);
    return response.data;
  }
}
